import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=25c8f7a2&scoped=true&"
import script from "./NextButton.vue?vue&type=script&lang=ts&"
export * from "./NextButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8f7a2",
  null
  
)

export default component.exports